import React, { useState } from 'react';
import { submitSubscribe } from '../utils/api';
import { toast } from 'sonner';

export const SubscribeForm = () => {
  const [data, setData] = useState({ firstName: '', lastName: '', email: '', phone: '' });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await submitSubscribe(data);
      if (res.success) {
        toast.success('Thanks for subscribing!');
        setData({ firstName: '', lastName: '', email: '', phone: '' });
      }
    } catch (err) {
      toast.error('Could not subscribe right now. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const inputCls = 'w-full px-4 py-2 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-orange';

  return (
    <form onSubmit={handleSubmit} className="space-y-2 mb-6" data-testid="subscribe-form">
      <div className="grid grid-cols-2 gap-2">
        <input
          type="text" required value={data.firstName}
          onChange={(e) => setData({ ...data, firstName: e.target.value })}
          placeholder="First name *" className={inputCls} data-testid="subscribe-first-name"
        />
        <input
          type="text" required value={data.lastName}
          onChange={(e) => setData({ ...data, lastName: e.target.value })}
          placeholder="Last name *" className={inputCls} data-testid="subscribe-last-name"
        />
      </div>
      <input
        type="email" required value={data.email}
        onChange={(e) => setData({ ...data, email: e.target.value })}
        placeholder="Email address *" className={inputCls} data-testid="subscribe-email"
      />
      <input
        type="tel" value={data.phone}
        onChange={(e) => setData({ ...data, phone: e.target.value })}
        placeholder="Phone number (optional)" className={inputCls} data-testid="subscribe-phone"
      />
      <button
        type="submit" disabled={submitting}
        className="w-full bg-brand-orange text-white px-4 py-2 rounded-md hover:bg-brand-orange-light transition font-semibold disabled:opacity-50"
        data-testid="footer-subscribe-btn"
      >
        {submitting ? 'Subscribing...' : 'Subscribe Now'}
      </button>
    </form>
  );
};

export default SubscribeForm;
